import React from 'react'
import { Button, Image, Modal, Grid } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class ResendDeletePlaybookInvitaion extends React.Component {

    constructor(props) {
        super(props);
    }

    handleClose = () => {
        dispatch.lifeCycle.resendAndDeleteInviteModal(false);
    }



    resendInvitation(invite) {
        invite.organizationId = this.props.organizationId;
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{invite.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let organizationObj = {
                    "name": this.props.selectedOrganisation.name
                }
                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: invite.email,
                    invite: invite,
                    invitationCode: invite._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: `You have been Invited to join "${this.props.teamName}" Playbook for "${this.props.selectedOrganisation.name}" Workspace on Aspenify Platform.`
                }
                dispatch.lifeCycle.resendInvitation(emailObject);
            }
        });

    }
    deleteInvitaion(invitData) {
        let message = <div className="confirmMessage">
            <h3>Delete Invitation</h3>
            <p>Are you sure that you wish to delete this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.lifeCycle.deleteInvitaionAsync(invitData);
            }
        });

    }


    render() {
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                size='mini'
                open={this.props.isPlaybookInvitationModalOpen}
                centered
                style={inlineStyle.modal}
                className="editRoleModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header style={{ color: '#3fa9f5' }}>Invited User
            </Modal.Header>
                <Modal.Content>

                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <ImageAvater
                                    user={this.props.editPlaybookInviteDetail}
                                    imageStyle="f_10 w_32 h_32 mar_0 pad_3"
                                    className="f_14 w_32 h_32 " />
                                <Grid.Row className="text-cap">
                                    <strong>{this.props.editPlaybookInviteDetail.firstName + ' ' + this.props.editPlaybookInviteDetail.lastName}</strong>
                                </Grid.Row>
                                <Grid.Row >
                                    <span>{this.props.editPlaybookInviteDetail.email}</span>
                                </Grid.Row>
                                <Grid.Row>
                                    <span style={{ "color": "#FFC68B" }}>Invited as <span className="text-cap">{this.props.editPlaybookInviteDetail.role}</span></span>
                                </Grid.Row>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </Modal.Content>
                <Modal.Actions>
                    <Button icon='redo' size="mini" className="bg-blue icon-button" onClick={() => { this.resendInvitation(this.props.editPlaybookInviteDetail) }} />
                    <Button icon='trash alternate' size="mini" className="bg-orange icon-button" onClick={() => { this.deleteInvitaion(this.props.editPlaybookInviteDetail) }} />
                    <Button className="button-cancel" id='cancelBtn' onClick={this.handleClose}> Close
                    </Button>

                </Modal.Actions>
            </Modal >
        )
    }
}

export default ResendDeletePlaybookInvitaion